import { render } from "./pdf-convert.vue?vue&type=template&id=1c899917&ts=true"
import script from "./pdf-convert.vue?vue&type=script&lang=ts"
export * from "./pdf-convert.vue?vue&type=script&lang=ts"

import "./pdf-convert.vue?vue&type=style&index=0&id=1c899917&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])